<script lang="ts">
    import { icons } from "../../../config"
    import { accessToken } from "../../../store"
    import { _ } from "svelte-i18n"
    import Icon from "../Icon.svelte"
    import Lightbox from "../Lightbox.svelte"

    export let file: Attachement
    export let operation: Operation | OperationOut
    export let viaId = false
    export let className: string = ""

    let lightboxOpen = false

    let iconPath: string
    let isImage = false
    let pass = "inline"
    $: fileExt = file.name.replace(/^.+\.([^\.]+)$/, "$1").toLowerCase()
    $: {
        isImage = false
        pass = "inline"
        switch (fileExt) {
            case "pdf":
                iconPath = icons.pdfFile
                break
            case "dxf":
                pass = "attachment"
                iconPath = icons.dxfFile
                break
            case "dwg":
                pass = "attachment"
                iconPath = icons.cadFile
                break
            case "xml":
                iconPath = icons.xmlFile
                break
            default:
                iconPath = icons.imageFile
                isImage = true
        }
    }

    let title: string
    $: {
        title = file.name
        if (fileExt != "xml")
            switch (file.name.replace(/^.+\-([^\.]+)\.[^\.]+/, "$1")) {
                case "A":
                    title = $_("components.table.fields.attachmentField.offer")
                    break
                case "O":
                    title = $_("components.table.fields.attachmentField.orderConfirmation")
                    break
                case "R":
                    title = $_("components.table.fields.attachmentField.invoice")
                    // Rechnungsnummer
                    let nameMatch = file.name.match(/\-([^\-]+)\-R\.[^\.]+$/)
                    if (nameMatch && nameMatch.length > 1) {
                        title += " " + nameMatch[1]
                    }
                    break
                case "L":
                    title = $_("components.table.fields.attachmentField.deliveryNote")
                    break
                case "2":
                    switch (file.name.replace(/^.+\-([^\.\-]+)-[^\.\-]\.[^\.]+/, "$1")) {
                        case "01":
                            title = $_("components.table.fields.attachmentField.twoDOverall")
                            break
                        case "02":
                            title = $_("components.table.fields.attachmentField.twoDDetail1")
                            break
                        case "03":
                        case "04":
                            title = $_("components.table.fields.attachmentField.twoDDetail2")
                            break
                        default:
                            title = $_("components.table.fields.attachmentField.twoDImage")
                    }
                    break
                case "3":
                    title = $_("components.table.fields.attachmentField.threeDImage")
                    break
                case "M":
                    title = $_("components.table.fields.attachmentField.assemblyInstruction")
                    break
                case "X":
                    title = $_("components.table.fields.attachmentField.dxfFile")
                    break
            }
    }
</script>

<a
    rel="noreferrer"
    href="/api/attachement?{$accessToken ? 'accessToken=' + $accessToken + '&' : ''}pass={pass}&op={viaId
        ? operation.id
        : operation.number}&f={file.name}&randomAntiCache={Math.random().toString()}"
    target="_blank"
    class="{className}"
    class:isImage
    on:click="{(e) => {
        if (isImage) {
            e.preventDefault()
            lightboxOpen = true
        }
    }}"
>
    <span class="icon">
        {#if isImage}
            <img
                src="/api/attachement?{$accessToken ? 'accessToken=' + $accessToken + '&' : ''}pass=inline&r=s&op={viaId
                    ? operation.id
                    : operation.number}&f={file.name}&type={operation.collectionName}"
                alt=""
                width="120"
            />
        {:else}
            <Icon path="{iconPath}" size="{className == 'overlay_auftrag' ? '24px' : '48px'}" />
        {/if}
        {#if isImage}
            <span class="overlay"><span class="material-icons">search</span></span>
        {/if}
    </span>
    <span class="text">{title}</span>
</a>

<Lightbox
    bind:open="{lightboxOpen}"
    imageUrl="/api/attachement?{$accessToken ? 'accessToken=' + $accessToken + '&' : ''}pass=attachment&op={viaId
        ? operation.id
        : operation.number}&f={file.name}"
    downloadUrl="/api/attachement?{$accessToken ? 'accessToken=' + $accessToken + '&' : ''}pass=attachment&op={viaId
        ? operation.id
        : operation.number}&f={file.name}&type={operation.collectionName}"
/>
